import {FC} from 'react';

import {PriceWithUsd} from 'components/currency/price-with-usd';
import {ProductTaxType} from 'generated/graphql';
import {calculateProductsTotalPrice, calculateProductsTotalPriceForDealer, QuotedProductPriceFields} from 'utils/quotes/calculator';

interface ProductsTotalPriceProps {
    dealer?: boolean;
    products: QuotedProductPriceFields[];
    taxes?: ProductTaxType[] | undefined;
    exchangeRate?: number | null;
};

export const ProductsTotalPrice: FC<ProductsTotalPriceProps> = ({products, dealer, taxes, exchangeRate}) => {
    const price = !dealer
        ? calculateProductsTotalPrice(products, taxes)
        : calculateProductsTotalPriceForDealer(products, taxes);
    return <PriceWithUsd brlAmount={price} exchangeRate={exchangeRate} />;
};
